import { useEffect, useState } from 'react'
import useGetFavoriteProducts from '../../Components/BasketPage/Hooks/useGetFavoriteProducts';
import { useFavoriteProducts } from '../../Providers/FavoriteProductsProvider';
import { toast } from 'react-toastify';
import { ConvertPriceToString } from '../../Helpers/CustomConverter';
import { useCart } from '../../Providers/CartProvider';
import { useLocation, useNavigate } from "react-router";
import YesNoCancelMessageModal from '../../Components/Components/Modals/YesNoCancelMessageModal';
import DiscountCode from '../../Components/Components/DiscountCode';
import ScrollUpArrow from '../../Components/Components/ScrollUpArrow';
import { useAuth } from '../../Providers/AuthProvider';
import { useSavedBaskets } from '../../Providers/SavedBasketsProvider';
import ErrorBoundary from '../../Components/ErrorBoundary/ErrorBoundary';
import SavedBasketTab from './Components/SavedBasketTab';
import FavoriteProductsTab from './Components/FavoriteProductsTab';
import LoadingSpinner from '../../Components/Components/LoadingSpinner';
import MobileAccountNavBar from '../../Components/MobileComponents/NavBarMobile.jsx/MobileAccountNavBar';
import { useParams } from '../../Providers/ParamsProvider';
import { AccountCurrentView } from '../../Data/PageModeEnums.ts';

import './SavedBasketsStyles.css'

const SaveBaskets = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const { params } = location.state || {}

    const { authState } = useAuth()
    const [pending, setPending] = useState(false)
    const { favoriteProducts, handleGetFavoriteProducts } = useGetFavoriteProducts(setPending)
    const { loadBasket, cartItems } = useCart()
    const { isMobile } = useParams()
    const [refreshFavoriteItemsTrigger, setRefreshFavoriteItemsTrigger] = useState(false)
    const tabs = ['Obserwowane produkty', 'Zapisane szybkokoszyki']
    const [activeTab, setActiveTab] = useState(params?.selectedTab && params.selectedTab == 'savedBasket' ? 'Zapisane szybkokoszyki' : 'Obserwowane produkty')
    const [selectedBaskets, setSelectedBaskets] = useState([])
    const [showQuestionAboutReplaceBasket, setShowQuestionAboutReplaceBasket] = useState(false)
    const [messageModalFunctionType, setMessageModalFunctionTyp] = useState('')
    const { setSelectedProducts } = useFavoriteProducts()
    const { savedBaskets, handleGetSavedBasket, isLoadingSavedBaskets } = useSavedBaskets()
    const [isLoadingBasket, setIsLoadingBasket] = useState(false)

    useEffect(() => {
        setSelectedProducts([])
    }, [])

    useEffect(() => {
        handleGetFavoriteProducts()
    }, [refreshFavoriteItemsTrigger])

    useEffect(() => {
        if (activeTab === 'Zapisane szybkokoszyki') {
            handleGetSavedBasket()
        }
    }, [activeTab])

    const handleCheckUncheckBasket = (basket, isChecked) => {
        if (isChecked) {
            setSelectedBaskets(prev => [...prev, basket])
        }
        else {
            setSelectedBaskets(prev => prev.filter(b => b.basketId !== basket.basketId))
        }
    }

    const handleSelectUnSelectAllBaskets = (savedBaskets, isChecked) => {
        if (savedBaskets && savedBaskets.length > 0) {
            if (isChecked) {
                setSelectedBaskets(savedBaskets)
            }
            else {
                setSelectedBaskets([])
            }
        }
    }

    const handleOrderSelectedBasketsItems = () => {
        if (selectedBaskets.length === 0) {
            toast.warning('Proszę wybrać szybkokoszyki')
            return
        }
        if (!authState.user) {
            toast.warning('Prosze się zalogować')
            return
        }
        if (!authState.custId) {
            toast.warning('Brak wybranego kontrahenta')
            return
        }
        setMessageModalFunctionTyp({ name: 'OrderMany', param: null })
        if (cartItems && cartItems.basketItems && cartItems.basketItems.length > 0) {
            setShowQuestionAboutReplaceBasket(true)
        }
        else {
            let messageModalFunctionType = { name: 'OrderMany', param: null } //przekazujemy, ponieważ setMessageModalFunctionTyp nie zdąrzy zmienic stanu :(
            handleMessageModalResult('No', messageModalFunctionType)
        }
    }

    const handleMessageModalResult = async (answer, messageModalFunctionTypeParam) => {
        setShowQuestionAboutReplaceBasket(false)
        if (answer === 'Cancel' || answer === null) {
            return
        }
        var replaceBasket = answer === 'Yes' ? true : false
        let tmpMessageModalFunctionType = messageModalFunctionTypeParam ? messageModalFunctionTypeParam : messageModalFunctionType
        switch (tmpMessageModalFunctionType.name) {
            case 'OrderMany':
                setIsLoadingBasket(true)
                setMessageModalFunctionTyp({ name: '', param: null })
                var selectedBasketsIds = selectedBaskets.map(x => parseInt(x.basketId))
                const loadRes = await loadBasket(selectedBasketsIds, replaceBasket)
                setIsLoadingBasket(false)
                if (!loadRes) {
                    toast.error('Błąd podczas wczytywania koszyka')
                    return
                }
                navigate('/Cart')
                break
            case 'AddToCart':
                setIsLoadingBasket(true)
                setMessageModalFunctionTyp({ name: '', param: null })
                const res = await loadBasket(tmpMessageModalFunctionType.param, replaceBasket)
                setIsLoadingBasket(false)
                if (!res) {
                    toast.error('Błąd podczas wczytywania koszyka')
                    return
                }
                navigate('/Cart')
                break
        }
    }

    const mainStyle = activeTab === 'Zapisane szybkokoszyki' ? 'col-12 col-xl-9' : 'col-12 '

    if (isLoadingBasket) {
        return <LoadingSpinner loadingText='Wczytywanie koszyka...' />
    }
    return (
        <>
            <ErrorBoundary>
                <YesNoCancelMessageModal
                    show={showQuestionAboutReplaceBasket}
                    onHide={handleMessageModalResult}
                    title={'Pytanie'}
                    message={'Twój koszyka zawiera już pozycje, co chcesz zrobić z zaznaczonymi pozycjami, które dodajesz do koszyka?'}
                    yesText='Nadpisz koszyk'
                    noText='Dopisz do koszyka'
                />

                <div className='container-fluid-with-paddings mt-4' style={{ marginBottom: isMobile ? '105px' : '45px' }}>
                    {isMobile && <div className='mb-2'><MobileAccountNavBar currentKey={AccountCurrentView.ZapisaneKoszyki} /></div>}
                    <ScrollUpArrow />
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="row">
                                <div className={`${mainStyle}`}>
                                    <div className='main-container-holder' style={{ borderBottom: '0' }}>
                                        <div className="tabs">
                                            <button
                                                className={`tab-button ${activeTab === "Obserwowane produkty" ? "active" : ""
                                                    }`}
                                                onClick={() => setActiveTab("Obserwowane produkty")}
                                            >
                                                Obserwowane produkty
                                            </button>
                                            <button
                                                className={`tab-button ${activeTab === "Zapisane szybkokoszyki" ? "active" : ""
                                                    }`}
                                                onClick={() => setActiveTab("Zapisane szybkokoszyki")}
                                            >
                                                Zapisane szybkokoszyki
                                            </button>
                                        </div>
                                    </div>
                                    <div>
                                        {activeTab === 'Obserwowane produkty' ?
                                            (<FavoriteProductsTab
                                                pending={pending}
                                                favoriteProducts={favoriteProducts}
                                                setRefreshFavoriteItemsTrigger={setRefreshFavoriteItemsTrigger}
                                                navigate={navigate}
                                                setIsLoadingBasket={setIsLoadingBasket}
                                            />)
                                            :
                                            (<SavedBasketTab
                                                handleCheckUncheckBasket={handleCheckUncheckBasket}
                                                handleSelectUnSelectAllBaskets={handleSelectUnSelectAllBaskets}
                                                setMessageModalFunctionTyp={setMessageModalFunctionTyp}
                                                setShowQuestionAboutReplaceBasket={setShowQuestionAboutReplaceBasket}
                                                savedBaskets={savedBaskets}
                                                handleGetSavedBasket={handleGetSavedBasket}
                                                isLoadingSavedBaskets={isLoadingSavedBaskets}
                                                handleMessageModalResult={handleMessageModalResult}
                                            />)}
                                    </div>
                                </div>
                                <div className="col-12 col-xl-3 ps-4 pe-4">
                                    {generateSideColumn(activeTab, selectedBaskets, handleOrderSelectedBasketsItems)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ErrorBoundary>
        </>
    )
}

const generateSideColumn = (activeTab, selectedBaskets, handleOrderSelectedBasketsItems) => {
    var netValue = selectedBaskets.length > 0 ? selectedBaskets.reduce((sum, basket) => sum + basket.netValue, 0) : 0
    var taxValue = selectedBaskets.length > 0 ? selectedBaskets.reduce((sum, basket) => sum + basket.taxValue, 0) : 0
    var grossValue = selectedBaskets.length > 0 ? selectedBaskets.reduce((sum, basket) => sum + basket.grossValue, 0) : 0

    if (activeTab === 'Zapisane szybkokoszyki') {
        return (
            <div className="row selected-baskets-summary position-sticky main-container-holder mt-2 mt-xl-0" style={{ top: '260px' }}>
                <div className="row">
                    <div className="col">
                        <span>Suma netto</span>
                    </div>
                    <div className="col-auto mb-2">
                        <span>{ConvertPriceToString(netValue)}</span>
                    </div>
                </div>
                <div className="row basket-page-underline">
                    <div className="col">
                        <span>VAT</span>
                    </div>
                    <div className="col-auto mb-2">
                        <span>{ConvertPriceToString(taxValue)}</span>
                    </div>
                </div>
                <div className="row basket-page-underline mt-2 mb-2">
                    <div className="col">
                        <b>Suma brutto</b>
                    </div>
                    <div className="col-auto mb-2">
                        <b>{ConvertPriceToString(grossValue)}</b>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <DiscountCode />
                    </div>
                </div>
                <button className='btn-app-primary mt-4' onClick={handleOrderSelectedBasketsItems}>Zamów teraz</button>
            </div>
        )
    }
}

export default SaveBaskets